import React, { Component, Fragment } from 'react';
import { Row, Col, Card, Button, Statistic, Icon, Table } from 'antd';
import { inject, observer } from 'mobx-react';
import { SessionForm } from './SessionForm';
import moment from 'moment-timezone';

@inject('store')
@observer
export class SessionsView extends Component {
    constructor(props) {
        super(props);
        this.state = { visible: false };
    }

    componentDidMount() {
        this.props.store.odysseyBotStore.getActiveTradingSession(this.props.match.params.id);
        this.props.store.odysseyBotStore.getCompleteTradingSessions(this.props.match.params.id);
    }

    showModal() {
        this.setState({
            visible: true
        });
    }

    handleCancel() {
        this.setState({
            visible: false
        });
    }

    render() {
        const { activeTradingSession, completeTradingSessions } = this.props.store.odysseyBotStore;

        return (
            <Row gutter={24}>
                <Col md={24}>{this.renderActiveSession()}</Col>
                <Col md={24}>
                    <Card
                        title={`Past Sessions`}
                        bordered={false}
                        style={{ marginTop: 15 }}
                        extra={
                            <Button
                                type="primary"
                                disabled={activeTradingSession != null}
                                onClick={this.showModal.bind(this)}
                            >
                                New Session
                            </Button>
                        }
                    >
                        <Table
                            dataSource={completeTradingSessions}
                            rowKey={'_id'}
                            columns={[
                                {
                                    title: 'Symbol',
                                    dataIndex: 'trading_pair',
                                    key: 'trading_pair'
                                },
                                {
                                    title: 'Name',
                                    dataIndex: 'name',
                                    key: 'name',
                                    sorter: (a, b) => {
                                        if (a.name < b.name) return -1;
                                        if (a.name > b.name) return 1;
                                        return 0;
                                    }
                                },
                                {
                                    title: 'Long Strategy',
                                    dataIndex: 'long_strategy_name',
                                    key: 'long_strategy_name'
                                },
                                {
                                    title: 'Short Strategy',
                                    dataIndex: 'short_strategy_name',
                                    key: 'short_strategy_name'
                                },
                                {
                                    title: 'PNL',
                                    dataIndex: 'pnl',
                                    key: 'pnl',
                                    render(text, o) {
                                        return (
                                            <span
                                                style={{
                                                    color: o.pnl >= 0 ? '#29c0b1' : '#FC3367'
                                                }}
                                            >
                                                {o.pnl.toFixed(8)}
                                            </span>
                                        );
                                    }
                                },
                                {
                                    title: 'Fees',
                                    dataIndex: 'fees',
                                    key: 'fees',
                                    render(text, o) {
                                        return (
                                            <span
                                                style={{
                                                    color: o.fees <= 0 ? '#29c0b1' : '#FC3367'
                                                }}
                                            >
                                                {o.fees.toFixed(8)}
                                            </span>
                                        );
                                    }
                                },
                                {
                                    title: 'Trades',
                                    dataIndex: 'trades',
                                    key: 'trades'
                                },
                                {
                                    title: 'Won',
                                    dataIndex: 'won',
                                    key: 'won'
                                },
                                {
                                    title: 'Lost',
                                    dataIndex: 'lost',
                                    key: 'lost'
                                },
                                {
                                    title: 'Cancelled',
                                    dataIndex: 'cancelled',
                                    key: 'cancelled'
                                },
                                {
                                    title: 'Win Rate',
                                    dataIndex: 'win_rate',
                                    key: 'win_rate',
                                    render(text, o) {
                                        const winRate =
                                            (o.won / (o.trades - o.cancelled)) * 100 || 0;
                                        return `${winRate.toFixed(2)}%`;
                                    }
                                },

                                {
                                    title: 'Duration',
                                    dataIndex: 'duration',
                                    key: 'duration',
                                    render(text, o) {
                                        const x = moment(o.created_at);
                                        const y = moment(o.updated_at);
                                        return moment.duration(x.diff(y)).humanize();
                                    }
                                },

                                {
                                    title: '',
                                    dataIndex: '',
                                    key: '',
                                    render: (text, o) => {
                                        return (
                                            <div>
                                                <Button
                                                    icon="database"
                                                    type="primary"
                                                    onClick={() => {
                                                        this.props.history.push(
                                                            `/a/odyssey/${this.props.match.params.id}/sessions/${o._id}`
                                                        );
                                                    }}
                                                >
                                                    History
                                                </Button>
                                                &nbsp;&nbsp;
                                                <Button
                                                    icon="delete"
                                                    type="danger"
                                                    onClick={() => {
                                                        this.props.store.odysseyBotStore.deleteTradingSessions(
                                                            this.props.match.params.id,
                                                            o._id
                                                        );
                                                    }}
                                                >
                                                    Delete
                                                </Button>
                                            </div>
                                        );
                                    }
                                }
                            ]}
                        />
                    </Card>
                </Col>
                <SessionForm visible={this.state.visible} onCancel={this.handleCancel.bind(this)} />
            </Row>
        );
    }

    renderActiveSession() {
        const { activeTradingSession } = this.props.store.odysseyBotStore;

        if (activeTradingSession) {
            const x = moment(activeTradingSession.created_at);
            const duration = moment.duration(x.diff(Date.now())).humanize();

            const winRate =
                (activeTradingSession.won /
                    (activeTradingSession.trades - activeTradingSession.cancelled)) *
                    100 || 0;
            return (
                <Card
                    title={`${activeTradingSession.trading_pair} ${
                        activeTradingSession.name
                    } - Win Rate: ${winRate.toFixed(2)}% Longs: ${
                        activeTradingSession.long_trades
                    } Shorts: ${activeTradingSession.short_trades}`}
                    bordered={false}
                    extra={
                        <span>
                            <Button
                                icon="database"
                                type="primary"
                                onClick={() => {
                                    this.props.history.push(
                                        `/a/odyssey/${this.props.match.params.id}/sessions/${activeTradingSession._id}`
                                    );
                                }}
                            >
                                History
                            </Button>
                            &nbsp;&nbsp;
                            <Button
                                loading={activeTradingSession.status === 'ACTIVE'}
                                icon="play-circle"
                                type="primary"
                                onClick={() => {
                                    this.props.store.odysseyBotStore.setActiveTradingSessionState(
                                        'ACTIVE'
                                    );
                                }}
                            >
                                {activeTradingSession.status === 'ACTIVE' ? 'Running' : 'Start'}
                            </Button>
                            &nbsp;&nbsp;
                            <Button
                                icon="pause-circle"
                                type="primary"
                                disabled={activeTradingSession.status === 'PAUSED'}
                                onClick={() => {
                                    this.props.store.odysseyBotStore.setActiveTradingSessionState(
                                        'PAUSED'
                                    );
                                }}
                            >
                                Pause
                            </Button>
                            &nbsp;&nbsp;
                            <Button
                                icon="stop"
                                type="danger"
                                onClick={() => {
                                    this.props.store.odysseyBotStore.setActiveTradingSessionState(
                                        'COMPLETE'
                                    );
                                }}
                            >
                                End
                            </Button>
                        </span>
                    }
                >
                    <div style={{ marginBottom: 10 }}>
                        <b>Long Strategy:</b> {activeTradingSession.long_strategy_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <b>Short Strategy:</b> {activeTradingSession.short_strategy_name}
                    </div>
                    <Row gutter={24}>
                        {activeTradingSession.account.type === 'managed' ? (
                            <Fragment>
                                <Col md={2}>
                                    <Statistic
                                        title="Investment"
                                        value={activeTradingSession.account.size}
                                        suffix={activeTradingSession.trading_pair.replace(
                                            'USD',
                                            ''
                                        )}
                                    />
                                </Col>
                                <Col md={1}>
                                    <Statistic
                                        title="Risk"
                                        value={activeTradingSession.account.risk}
                                        suffix="%"
                                    />
                                </Col>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <Col md={3}>
                                    <Statistic
                                        title="Position Size"
                                        value={activeTradingSession.account.position_size}
                                        suffix="USD"
                                    />
                                </Col>
                                <Col md={1}>
                                    <Statistic
                                        title="Leverage"
                                        value={activeTradingSession.account.leverage}
                                        suffix="%"
                                    />
                                </Col>
                            </Fragment>
                        )}

                        <Col md={3}>
                            <Statistic
                                title="PNL"
                                value={activeTradingSession.pnl.toFixed(8)}
                                precision={8}
                                valueStyle={{
                                    color: activeTradingSession.pnl >= 0 ? '#29c0b1' : '#FC3367'
                                }}
                                prefix={
                                    activeTradingSession.pnl >= 0 ? (
                                        <Icon type="arrow-up" />
                                    ) : (
                                        <Icon type="arrow-down" />
                                    )
                                }
                                suffix={activeTradingSession.trading_pair.replace('USD', '')}
                            />
                        </Col>

                        <Col md={3}>
                            <Statistic
                                title="Invested"
                                value={activeTradingSession.invested.toFixed(8)}
                                precision={8}
                                suffix={activeTradingSession.trading_pair.replace('USD', '')}
                            />
                        </Col>

                        <Col md={3}>
                            <Statistic
                                title="Fees"
                                value={activeTradingSession.fees.toFixed(8)}
                                precision={8}
                                valueStyle={{
                                    color: activeTradingSession.fees <= 0 ? '#29c0b1' : '#FC3367'
                                }}
                                suffix={activeTradingSession.trading_pair.replace('USD', '')}
                            />
                        </Col>

                        <Col md={2}>
                            <Statistic title="Trades" value={activeTradingSession.trades} />
                        </Col>
                        <Col md={2}>
                            <Statistic title="Won" value={activeTradingSession.won} />
                        </Col>
                        <Col md={2}>
                            <Statistic title="Lost" value={activeTradingSession.lost} />
                        </Col>
                        <Col md={2}>
                            <Statistic title="Cancelled" value={activeTradingSession.cancelled} />
                        </Col>
                        <Col md={2}>
                            <Statistic title="Duration" value={duration} />
                        </Col>
                    </Row>
                </Card>
            );
        }

        return null;
    }
}

// ```
// Entry 100 contracts @ 9716 = 0.010292 BTC
// SL    100 Contracts @ 9674 ($42)
// Risk/Reward 1
// ---------STANDARD ------------
// TP1   100 @ 9758 (9716 + 42)
// Profit: $100.43

// ---------SCALE OUT 50/50------------
// TP1   50(0.005146 BTC) @ 9800 (9716 + 42*2) = $50.43
// TSL(SL Strike 9716)   50(0.005146 BTC) TRAIL 9800 -42*2 = $50.00 (PROFIT: $100.43)
// TSL(SL Strike 9900)   50(0.005146 BTC) TRAIL 9800 -42*2 = $50.95 (PROFIT: $101.37)
// ---------SCALE OUT 75/25------------
// TP1   75(0.007719 BTC) @ 9779 (9716 + 42*1.5) = $75.48
// TSL(SL Strike 9716)   25(0.002573 BTC) TRAIL 9779 -42*1.5 = $25.00 (PROFIT: $100.48)
// TSL(SL Strike 9900)   25(0.002573 BTC) TRAIL 9779 -42*1.5 = $25.47 (PROFIT: $100.95)

// ```;



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/SessionsView/index.js